import React from 'react'
import Logo from '../ui/Logo'
import './Auth.css'

// The frame for the pages around the app: sign-in, can't-reach, agreements
// and the card-payment thank-you. One composition at every width (review
// 2026-10-14): a bordered card centred on the page, the logo at its top.
// Under it, the brand line — except on the thank-you page, which her
// clients see (panel={false}).
export default function AuthLayout({ children, panel = true }: { children: React.ReactNode; panel?: boolean }) {
  return (
    <div className="auth-container">
      <main className="auth-phone">{children}</main>
      {panel && <p className="auth-brand-line">Build the beauty business that fits your life.</p>}
    </div>
  )
}

// AuthLogo heads each of those pages' forms.
export function AuthLogo() {
  return <Logo className="auth-form-logo" height={28} />
}
